function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRatingYelp5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rating_x5F_yelp_x5F_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "144px",
    height: "48px",
    viewBox: "0 0 144 48",
    style: {
      enableBackground: "new 0 0 144 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32323"
    },
    d: "M22.1,36h-16c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C26.1,34.209,24.309,36,22.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32323"
    },
    d: "M51.1,36h-16c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C55.1,34.209,53.309,36,51.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32323"
    },
    d: "M80.1,36h-16c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C84.1,34.209,82.309,36,80.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32323"
    },
    d: "M109.1,36h-16c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C113.1,34.209,111.309,36,109.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32323"
    },
    d: "M138,36h-16c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C142,34.209,140.209,36,138,36z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "14.1,15.009 16.76,20.811 23.1,21.555 18.404,25.871 19.827,32.191 14.1,28.918  8.373,32.191 9.796,25.871 5.1,21.555 11.44,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "43.1,15.009 45.76,20.811 52.1,21.555 47.404,25.871 48.827,32.191 43.1,28.918  37.373,32.191 38.796,25.871 34.1,21.555 40.44,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.1,15.009 74.76,20.811 81.1,21.555 76.404,25.871 77.827,32.191 72.1,28.918  66.373,32.191 67.796,25.871 63.1,21.555 69.44,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "101.1,15.009 103.76,20.811 110.1,21.555 105.404,25.871 106.827,32.191 101.1,28.918  95.373,32.191 96.796,25.871 92.1,21.555 98.44,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "130.1,15.009 132.76,20.811 139.1,21.555 134.404,25.871 135.827,32.191 130.1,28.918  124.373,32.191 125.796,25.871 121.1,21.555 127.44,20.811  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRatingYelp5);
export default __webpack_public_path__ + "static/media/icon-rating_yelp_5.3d8bc20b87e18b1217efa2e04090677f.svg";
export { ForwardRef as ReactComponent };